import React, { Component } from 'react';
import ModalForm from '../../comum/components/ModalForm';
import { Button, Row, Col, CardTitle, Label } from 'reactstrap'
import FormInputSimples from '../../comum/components/FormInputSimples';
import FormSelectSimples from '../../comum/components/FormSelectSimples';
import CardAtencao from '../../comum/components/CardAtencao';
import CheckboxField from '../../comum/components/CheckboxField';
import Checkbox from '../../comum/components/Checkbox';
import ModalAviso from '../../comum/components/ModalAviso';
import { inject, observer } from 'mobx-react'

@inject("store")
@observer
export default class ModalAlterarSenha extends Component {
    /* Ajuste para publicação */
    constructor(props) {
        super(props)
        
        this.loginStore = this.props.store.loginStore;
        this.controller = this.props.controller;
        this.state = {
            salvo: false
        }
    }

    SalvarSenha = async () => {
        this.loginStore.salvarSenhaUsuario();
    }

    validar = () => {
        return
    }

    componentDidMount = () => {
       //
    }

    renderAlterar() {
        return (
            <ModalForm
                className="tamanho-modal-500"
                labelConfirmar="ALTERAR"
                labelCancelar={"CANCELAR"}
                onClickSalvar={() => this.SalvarSenha()}
                onClickCancelar={() => this.loginStore.fecharModalAlterarSenha()}
        >
                <h2>Altera Senha</h2>
                <Row className="mb-0">
                    <Col className="mb-0">
                        <Row className="mb-0">                            
                            <FormInputSimples inputClassName="noneCase"
                                              type={"password"}
                                              titulo="Senha Atual" xl={12} lg={12} md={12} sm={12} xs={12}
                                              dado={this.loginStore.senhaAtual}
                                              obrigatorio={true}
                                              onChange={(event) => this.loginStore.setSenhaAtual(event.target.value)}
                            />
                            <FormInputSimples inputClassName="noneCase"
                                              type={"password"}
                                              titulo="Nova Senha" xl={12} lg={12} md={12} sm={12} xs={12}
                                              dado={this.loginStore.novaSenha}
                                              obrigatorio={true}
                                              onChange={(event) => this.loginStore.setNovaSenha(event.target.value)}
                            />
                            <FormInputSimples className="mb-0"
                                              inputClassName="noneCase"
                                              type={"password"}
                                              titulo="Confirmar" xl={12} lg={12} md={12} sm={12} xs={12}
                                              dado={this.loginStore.confirmaSenha}
                                              obrigatorio={true}
                                              onChange={(event) => this.loginStore.setConfirmaSenha(event.target.value)}
                            />
                        </Row>
                    </Col>                    
                </Row>
                {this.loginStore.msgSenha && 
                <Row className="m-0 p-0">
                    <Col className="m-0 p-0">
                        <Label className="label-danger">{this.loginStore.msgSenha}</Label>
                    </Col>
                </Row>}
            </ModalForm>
        )
    }

    renderSenhaSalva() {
        return (
            <ModalForm
                className="tamanho-modal-100"
                esconderSalvar={true}
                labelCancelar={"FECHAR"}
                onClickSalvar={() => this.SalvarSenha()}
                onClickCancelar={() => this.loginStore.fecharModalAlterarSenha()}
            >
                <h2>{this.loginStore.msgSenha}</h2>
            </ModalForm>
        )
    }

    render() {
        return (
            this.loginStore.senhaAlterada ? this.renderSenhaSalva(): this.renderAlterar()
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/login/components/ModalAlterarSenha.js